var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2903",
    "data-name": "Path 2903",
    d: "M17.5,0A17.5,17.5,0,1,0,35,17.5,17.514,17.514,0,0,0,17.5,0m0,5.833A2.917,2.917,0,1,1,14.583,8.75,2.925,2.925,0,0,1,17.5,5.833m5.717,21.292-2.669,1.167-2.8-6.417h-.481l-2.8,6.417L11.8,27.125l2.8-6.417V15.56L8.225,13.008,9.3,10.3l7.029,2.815H18.7L25.725,10.3,26.8,13.008,20.431,15.56v5.148l2.8,6.417Z",
    fill: "#00b4d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/access_icon.bdd7a6bfa8475f22afbef9d923f77c4c.svg";
export { ForwardRef as ReactComponent };